<template>
	<div @click="toggleProjectPin" class="pin-button-container">
		<AppTooltip position="bottom" :text="`${useIsProjectMenuPinned ? 'Unpin' : 'Pin'} menu`">
			<div class="flex-centerize width-100 height-100">
				<AppIcon :width="6" :height="16" :name="`${useIsProjectMenuPinned ? 'pinned' : 'pin'}-projects-menu`" />
			</div>
		</AppTooltip>
	</div>
</template>

<script>
import AppTooltip from '@/components/common/AppTooltip';
import { setIsProjectMenuPinned } from '@/store/modules/appLayout/actions';
import { useIsProjectMenuPinned } from '@/store/modules/appLayout/getters';
import { mapGettersShorthand, mapActionsShorthand } from '@/store/utils/mappers';

export default {
	name: 'PinProjectMenuButton',
	components: { AppTooltip },
	props: {},
	computed: {
		...mapGettersShorthand({ useIsProjectMenuPinned }),
	},
	methods: {
		...mapActionsShorthand({ setIsProjectMenuPinned }),
		toggleProjectPin() {
			this.$emit('close');
			this.setIsProjectMenuPinned({ isPinned: !this.useIsProjectMenuPinned });
		},
	},
};
</script>

<style scoped lang="scss">
.pin-button-container {
	cursor: pointer;
	border-radius: 50%;
	background: var(--white);
	border: 1px solid #e7e7ed;
	width: $pin-projects-button-size;
	height: $pin-projects-button-size;
	&:hover {
		background: #efeff3;
	}
}
</style>
